import { useContext, useMemo } from 'react';
import { MobXProviderContext } from 'mobx-react';
// Hook for getting store from Mobx Provider.
// Does not support multiple stores with same type in provider context
export default function useStore(storeClass) {
    const storeMap = useContext(MobXProviderContext);
    const store = useMemo(() => {
        const stores = Object.values(storeMap);
        return stores.find((store) => store instanceof storeClass);
    }, [storeMap, storeClass]);
    if (!store) {
        throw new Error(`no store '${storeClass.name}' passed to Mobx Provider`);
    }
    return store;
}
